/*
 * fn: isCardPrinting
 *
 * Determines if a card is a specific printing or a "generic" card
 *
 */
import { type CardIdType } from '@/defs/card'

import { parseCardId } from './parseCardId'

export const isCardPrinting = (cardId: CardIdType) => {
  const { collectorNumber, set } = parseCardId(cardId)
  return !!collectorNumber || !!set
}
